<template>
    <hot-dropdown
      class="menu-notifications"
      slot="header-actions"
      @open="onOpenDropdown"
      @close="onCloseDropdown"
      tabindex="0"
      @keyup.enter="toggleTab"
      @keyup.space="toggleTab"
    >
      <hot-menu-item
        id="header-notifications"
        class="dropdown-button _rounded-lg"
        :class="{'_bg-gray-200': isActive}"
        slot="button"
      >
        <accessible-icon
          class="hot-application-menu__icon"
          :class="{'_text-brand-primary': isActive}"
          iconName="bell"
          iconFamily="fal"
          :description="$t('header.notificationsTab.title')"
        />
      </hot-menu-item>
      <div class="_py-2" slot="menu">
        <hot-dropdown-menu-header class="_text-2" slot="menu">{{$t('header.notificationsTab.title')}}</hot-dropdown-menu-header>
        <div class="notifications-list _overflow-hidden">
          <hot-dropdown-menu-item v-for="({ title, description, createdAt }, index) in updates" :key="index" @click="openDialog(index)" class="_px-5 _line-height-sm _d-flex">
              <div class="notification-item-icon _text-blue-light">
                <font-awesome-icon :icon="['fas', 'circle']" class="_mr-4 _mt-2"/>
              </div>
              <div>
                <span class="menu-item-description _text-2" v-if="description">
                  <strong class="_text-2">{{ title }}: </strong>
                  {{ description }}
                </span>
                <small class="_text-gray-500 _d-block _mt-1" v-if="createdAt">{{ formatDateRelative(createdAt) }}</small>
              </div>
          </hot-dropdown-menu-item>
        </div>
        <div class="_d-flex _justify-content-center _pt-1">
          <button class="hot-button hot-button--tertiary" type="button" @click="openDialog">
            {{$t('header.notificationsTab.showAll')}}
          </button>
        </div>
      </div>
    </hot-dropdown>
</template>

<script>
import { mapState } from 'vuex'
import formatDistance from 'date-fns/formatDistance'
import AccessibleIcon from 'core/components/AccessibleIcon/AccessibleIcon.vue'

export default {
  name: 'HeaderNotifications',
  components: {
    AccessibleIcon
  },
  data () {
    return {
      isActive: false
    }
  },
  computed: {
    ...mapState('userNotifications', ['updates'])
  },
  methods: {
    formatDateRelative (date) {
      const relativeDate = formatDistance(date, new Date(), {
        locale: this.localeData,
        addSuffix: true
      })

      return relativeDate.charAt(0).toUpperCase() + relativeDate.slice(1)
    },
    openDialog (id) {
      this.$event.emit('open:user-notifications-dialog', {
        type: 'updates',
        id: id
      })
    },
    onOpenDropdown () {
      this.closeNotificationsDialog()
      this.isActive = true
    },
    onCloseDropdown () {
      this.isActive = false
    },
    closeNotificationsDialog () {
      this.$event.emit('close:user-notifications-dialog')
    },
    toggleTab (ev) {
      this.$emit('toggleTab', 'header-notifications')
    }
  }

}
</script>

<style lang="scss" scoped>
    @import '~stylesheets/meta';

    .notifications-list {
      max-height: 260px;
    }

    .menu-notifications {
      --dropdown-menu-width: 480px;
    }

    .notification-item-icon {
      font-size: 0.5rem;
    }

    .menu-item-description {
        height: 48px;
        max-height: 48px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
</style>
